import React, { useRef, useState } from 'react';

import { HLSPlayer } from '@vlabs/pages/queue/hls-player/HLSPlayer';

import { rotationScale } from './math';
import type { HLSMediaProps, TSize } from './types';

export function HLSMedia({
  onChange,
  rotationDeg = 0,
  src = undefined,
  token = undefined,
}: HLSMediaProps): React.JSX.Element {
  const rootRef = useRef<HTMLDivElement | null>(null);
  const [originSize, setOriginSize] = useState<TSize | undefined>(undefined);

  const rootSize = rootRef.current ? {
    width: rootRef.current.clientWidth,
    height: rootRef.current.clientHeight,
  } : undefined;

  const styleTransform = (originSize && rootSize)
    ? `rotate(${rotationDeg}deg) scale(${1 / rotationScale(originSize, rootSize, rotationDeg)})`
    : 'none';

  const getMediaSize = (e: Event) => {
    const v = e.currentTarget as HTMLVideoElement;
    if (v?.videoWidth && v?.videoHeight) {
      const mediaSize = { width: v.videoWidth, height: v.videoHeight };
      setOriginSize(mediaSize);
      onChange({
        width: rotationDeg % 180 === 0 ? v.videoWidth : v.videoHeight,
        height: rotationDeg % 180 === 0 ? v.videoHeight : v.videoWidth,
      });
    }
  };

  return (
    <div
      ref={rootRef}
      style={{
        width: '100%',
        height: '100%',
        transform: styleTransform,
      }}
    >
      <HLSPlayer
        controls={false}
        height="100%"
        muted
        onLoadedMetadata={getMediaSize}
        src={src}
        token={token}
        width="100%"
      />
    </div>
  );
}
